<script setup lang="ts">
import IconButton from '@/uiKit/IconButton.vue'
import ToolTip from '@/uiKit/ToolTip.vue'

defineEmits<{
  (e: 'open' | 'open-mousedown'): void
}>()
</script>

<template>
  <div class="flex size-7 min-w-7 items-center justify-center p-0.5">
    <ToolTip
      title="Open citations for this field"
      :auto-placement-options="{ allowedPlacements: ['top', 'top-end'] }"
    >
      <IconButton
        aria-label="AI citations"
        icon="idea"
        size="md"
        variant="transparent"
        @click="$emit('open')"
        @mousedown="$emit('open-mousedown')"
      />
    </ToolTip>
  </div>
</template>
